import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { DirtyWrapper, LoadingPage } from 'Components';
import { resetDirty } from 'State/dirtyTracking/actions';
import { submitForm, resetForm } from 'State/forms/actions';
import { CreateEditTruckRouteScheduleEnum } from 'Common/FieldEnum';
import { CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME } from 'Common/FormEnum';
import {
  CreateEditPageEnum,
  GenericEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import {
  createToast,
  toastType,
  errorToast,
  toastSuccess,
} from 'Common/ToastHelper';

import { CreateEditTruckRouteSchedule } from '../../truckroutes/containers/createedittruckrouteschedule/CreateEditTruckRouteSchedule';
import * as CreateEditTruckRouteScheduleSelectors from '../state/createedittruckrouteschedule/selectors';
import {
getTruckRoute,
getTruckRouteSchedule,
clearTruckRouteScheduleData,
saveTruckRouteSchedule,
clearTruckRouteScheduleErrors,
clearSavedMessage,
} from '../state/createedittruckrouteschedule/actions';
import {
  BASE_URL,
  getSaveObject,
  getDuplicateTimeSlots,
} from './../helper/index';

class CreateEditTruckRouteSchedulePageContainer extends Component {
  static path = `${BASE_URL}/schedule/:isNewEdit/:id`;

  static propTypes = {
    truckRouteListData: PropTypes.array,
    truckRouteListDataLoading: PropTypes.bool.isRequired,
    truckRouteListDataLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    truckRouteScheduleDetailData: PropTypes.object,
    truckRouteScheduleDetailLoading: PropTypes.bool.isRequired,
    truckRouteScheduleDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    savedRouteSchedule: PropTypes.string.isRequired,
    saveError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    saveRouteScheduleLoading: PropTypes.bool.isRequired,
    truckRouteGridData: PropTypes.array,
    getTruckRoute: PropTypes.func.isRequired,
    getTruckRouteSchedule: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    clearTruckRouteScheduleData: PropTypes.func.isRequired,
    saveTruckRouteSchedule: PropTypes.func.isRequired,
    clearTruckRouteScheduleErrors: PropTypes.func.isRequired,
    clearSavedMessage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    truckRouteListData: [],
    truckRouteScheduleDetailData: null,
    truckRouteListDataLoadingError: null,
    truckRouteScheduleDetailError: null,
    saveRouteScheduleLoading: false,
    truckRouteGridData: [],
  };

  componentDidMount = () => {
    const { isNewEdit, id } = this.props.match.params;
    this.props.getTruckRoute();
    if (isNewEdit === CreateEditPageEnum.EDIT) {
      this.props.getTruckRouteSchedule(id);
    }
  };

  componentDidUpdate(prevProps) {
    const {
      clearTruckRouteScheduleErrors,
      savedRouteSchedule,
      clearSavedMessage,
    } = this.props;

    if (
      errorToast(this.props, prevProps, 'truckRouteScheduleDetailError') ||
      errorToast(this.props, prevProps, 'truckRouteListDataLoadingError') ||
      errorToast(this.props, prevProps, 'saveError')
    ) {
      clearTruckRouteScheduleErrors();
    }
    if (
      savedRouteSchedule &&
      savedRouteSchedule !== prevProps.savedRouteSchedule
    ) {
      toastSuccess(savedRouteSchedule);
      clearSavedMessage();
      this.props.history.push(`${BASE_URL}`);
      this.props.resetDirty();
    }
  }

  componentWillUnmount() {
    const {
      truckRouteScheduleDetailData,
      clearTruckRouteScheduleData,
    } = this.props;
    if (truckRouteScheduleDetailData) {
      clearTruckRouteScheduleData();
    }
    this.props.resetForm(CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME);
    this.props.resetDirty();
  }

  getBreadCrumbs = () => {
    const { isNewEdit } = this.props.match.params;
    return [
      {
        title: 'Truck Route Schedule',
        link: BASE_URL,
      },
      {
        title:
          isNewEdit !== CreateEditPageEnum.EDIT
            ? 'Create New'
            : 'Edit Truck Route Schedule',
        link: '',
      },
    ];
  };

  getMainProps = () => {
    const { truckRouteGridData } = this.props;

    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [
        {
          content: 'Save',
          onClick: this.completeSave,
          disabled: truckRouteGridData && !truckRouteGridData.length,
        },
      ],
      shown: true,
    };
    return {
      toolbox,
    };
  };

  getRootUrl = () => {
    return BASE_URL;
  };

  completeSave = () => {
    this.props.submitForm(CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME);
  };

  handleSubmit = values => {
    const { isNewEdit, id } = this.props.match.params;
    const routeId = isNewEdit ? id : 0;
    const duplicateTimeSlots = getDuplicateTimeSlots(
      values[CreateEditTruckRouteScheduleEnum.TruckRouteTimeComponent]
    );
    if (duplicateTimeSlots && duplicateTimeSlots.length > 0) {
      createToast(
        toastType.error,
        'Error',
        'Please clear duplicate time slot(s). \n' + duplicateTimeSlots,
        true
      );
    } else {
      const reqObj = getSaveObject(routeId, values);
      this.props.saveTruckRouteSchedule(reqObj);
    }
  };

  getTruckRouteSchedule = () => {
    let initialValues = {};
    const { isNewEdit } = this.props.match.params;
    const {
      truckRouteScheduleDetailData,
      truckRouteScheduleDetailError,
      truckRouteListData,
      truckRouteListDataLoading,
    } = this.props;
    let render = false;
    if (truckRouteScheduleDetailData && isNewEdit === CreateEditPageEnum.EDIT) {
      initialValues = {
        [CreateEditTruckRouteScheduleEnum.Description]:
          truckRouteScheduleDetailData.Description,
        [CreateEditTruckRouteScheduleEnum.DayOfWeek]:
          truckRouteScheduleDetailData[
            CreateEditTruckRouteScheduleEnum.DayOfWeek
          ],
        [CreateEditTruckRouteScheduleEnum.TruckRouteTimeComponent]:
          truckRouteScheduleDetailData[
            CreateEditTruckRouteScheduleEnum.TimeSlot
          ],
        [CreateEditTruckRouteScheduleEnum.TruckRouteScheduleGrid]:
          truckRouteScheduleDetailData[
            CreateEditTruckRouteScheduleEnum.RouteIds
          ],
      };
      render = true;
    } else if (
      isNewEdit === CreateEditPageEnum.NEW ||
      truckRouteScheduleDetailError
    ) {
      initialValues = {
        [CreateEditTruckRouteScheduleEnum.Description]: GenericEnum.EmptyString,
        [CreateEditTruckRouteScheduleEnum.DayOfWeek]: [],
        [CreateEditTruckRouteScheduleEnum.TruckRouteTimeComponent]: [''],
        [CreateEditTruckRouteScheduleEnum.TruckRouteScheduleGrid]: [],
      };
      render = true;
    }
    return render ? (
      <Fragment>
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper>
          {showDirtyConfirm => (
            <Main {...this.getMainProps()} shouldNotUsePageWidth>
              <CreateEditTruckRouteSchedule
                initialValues={initialValues}
                truckRouteListData={truckRouteListData}
                truckRouteListDataLoading={truckRouteListDataLoading}
                onSubmit={this.handleSubmit}
                truckRouteScheduleDetailData={truckRouteScheduleDetailData}
                isNewEdit={isNewEdit === CreateEditPageEnum.NEW}
              />
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    ) : null;
  };

  render() {
    const {
      truckRouteScheduleDetailLoading,
      truckRouteListDataLoading,
      saveRouteScheduleLoading,
    } = this.props;

    return truckRouteScheduleDetailLoading ||
      truckRouteListDataLoading ||
      saveRouteScheduleLoading ? (
      <LoadingPage />
    ) : (
      this.getTruckRouteSchedule()
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME);

const mapStateToProps = state => {
  return {
    truckRouteListData: CreateEditTruckRouteScheduleSelectors.getSortedRouteIds(
      state
    ),
    truckRouteListDataLoading: CreateEditTruckRouteScheduleSelectors.getTruckRouteListDataLoading(
      state
    ),
    truckRouteListDataLoadingError: CreateEditTruckRouteScheduleSelectors.getTruckRouteListDataLoadingError(
      state
    ),
    truckRouteScheduleDetailData: CreateEditTruckRouteScheduleSelectors.getTruckRouteScheduleDetailData(
      state
    ),
    truckRouteScheduleDetailLoading: CreateEditTruckRouteScheduleSelectors.getTruckRouteScheduleDetailLoading(
      state
    ),
    truckRouteScheduleDetailError: CreateEditTruckRouteScheduleSelectors.getTruckRouteScheduleDetailError(
      state
    ),
    savedRouteSchedule: CreateEditTruckRouteScheduleSelectors.getSaveData(
      state
    ),
    saveError: CreateEditTruckRouteScheduleSelectors.getSaveLoadingError(state),
    saveRouteScheduleLoading: CreateEditTruckRouteScheduleSelectors.getSaveLoading(
      state
    ),
    truckRouteGridData: selector(
      state,
      CreateEditTruckRouteScheduleEnum.TruckRouteScheduleGrid
    ),
  };
};

const mapDispatchToProps = {
  getTruckRoute,
  getTruckRouteSchedule,
  submitForm,
  resetForm,
  resetDirty,
  clearTruckRouteScheduleData,
  saveTruckRouteSchedule,
  clearTruckRouteScheduleErrors,
  clearSavedMessage,
};

export const CreateEditTruckRouteSchedulePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditTruckRouteSchedulePageContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/subpages/CreateEditTruckRouteSchedulePage.js